import CompanyApiTab from './CompanyApiTab';

export default CompanyApiTab;
